export enum FolderTemplateNodeType {
  Folder = '50',
  UploadRequest = '1',
}

export interface FolderNode {
  id: string;
  name: string;
  pid: string | null;
  isExpanded?: boolean;
  isEditing?: boolean;
  children?: FolderNode[];
  hasChildren?: boolean;
  level?: number;
  tp: FolderTemplateNodeType;
  originalName?: string;
}
